import { render, staticRenderFns } from "./FavouritesPage.vue?vue&type=template&id=02b42d54&"
import script from "./FavouritesPage.vue?vue&type=script&lang=js&"
export * from "./FavouritesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports